module.exports = "<div class=\"container\">\r\n    <app-top-bar></app-top-bar>\r\n    <router-outlet></router-outlet>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1